import * as React from 'react';

import { formatBalance } from 'helpers/format-number';

import { TotalRewards } from 'types/vote';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { Amount, AquaLogo, Card, Container, Description } from './DividedRewards.styled';

interface DividedRewardsProps {
    totalRewards: TotalRewards;
    error?: boolean;
}

const DividedRewards = ({ totalRewards, error }: DividedRewardsProps): React.ReactNode => (
    <Container>
        <Card>
            <AquaLogo />
            <div>
                <Amount aria-busy={!totalRewards && !error}>
                    {totalRewards ? (
                        `${formatBalance(totalRewards.total_daily_amm_reward)} AQUA`
                    ) : error ? (
                        '— AQUA'
                    ) : (
                        <>
                            <Bar $width="8ch" $height="0.65em" />
                            &nbsp;AQUA
                        </>
                    )}
                </Amount>
                <Description>
                    <b>Aquarius AMM</b> daily reward
                </Description>
            </div>
        </Card>

        <Card>
            <AquaLogo />
            <div>
                <Amount aria-busy={!totalRewards && !error}>
                    {totalRewards ? (
                        `${formatBalance(totalRewards.total_daily_sdex_reward)} AQUA`
                    ) : error ? (
                        '— AQUA'
                    ) : (
                        <>
                            <Bar $width="8ch" $height="0.65em" />
                            &nbsp;AQUA
                        </>
                    )}
                </Amount>
                <Description>
                    <b>SDEX</b> daily reward
                </Description>
            </div>
        </Card>
    </Container>
);

export default DividedRewards;
